export const BOT_NAMES = [
  { name: 'Дулмаа', englishName: 'Dulmaa', slug: 'dulmaa' },
  { name: 'Балдан', englishName: 'Baldan', slug: 'baldan' },
  { name: 'Баагий', englishName: 'Baagii', slug: 'baagii' },
  { name: 'Доржоо', englishName: 'Dorjoo', slug: 'dorjoo' },
  { name: 'Номин', englishName: 'Nomin', slug: 'nomin' },
  { name: 'Цэрэн', englishName: 'Tseren', slug: 'tseren' },
  { name: 'Дэжид', englishName: 'Dejid', slug: 'dejid' },
  { name: 'Долгор', englishName: 'Dolgor', slug: 'dolgor' },
  { name: 'Норжмаа', englishName: 'Norjmaa', slug: 'norjmaa' },
  { name: 'Лхам', englishName: 'Lkham', slug: 'lkham' },
  { name: 'Цэнд', englishName: 'Tsend', slug: 'tsend' },
  { name: 'Ханд', englishName: 'Khand', slug: 'khand' },
  { name: 'Лувсан', englishName: 'Luvsan', slug: 'luvsan' },
  { name: 'Жамбал', englishName: 'Jambal', slug: 'jambal' },
  { name: 'Дамдин', englishName: 'Damdin', slug: 'damdin' },
  { name: 'Дугар', englishName: 'Dugar', slug: 'dugar' },
  { name: 'Содном', englishName: 'Sodnom', slug: 'sodnom' },
  { name: 'Ринчин', englishName: 'Rinchin', slug: 'rinchin' },
  { name: 'Пагма', englishName: 'Pagma', slug: 'pagma' },
  { name: 'Янжин', englishName: 'Yanjin', slug: 'yanjin' },
  { name: 'Гомбо', englishName: 'Gombo', slug: 'gombo' },
  { name: 'Чойжил', englishName: 'Choijil', slug: 'choijil' },
  { name: 'Самдан', englishName: 'Samdan', slug: 'samdan' },
  { name: 'Санж', englishName: 'Sanj', slug: 'sanj' },
  { name: 'Даш', englishName: 'Dash', slug: 'dash' },
  { name: 'Сүрэн', englishName: 'Suren', slug: 'suren' },
] as const;
